import { ListItem, Text } from "@chakra-ui/react";

function ListItems({ detail, label }) {
  return (
    <ListItem>
      <Text as={"span"} fontWeight={"bold"}>
        {label}:
      </Text>{" "}
      {detail}
    </ListItem>
  );
}

export default ListItems;
